import * as React from "react";

import ProjectsTable from "@v1/components/dashboard/projects/ProjectsTable";
import DashboardLayout from "@v2/features/dashboard/DashboardLayout";
import { projectRouter } from "@v2/trpc/routes/project";
import { Outlet } from "react-router-dom";

const AllProjects: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { data, isLoading } = projectRouter.listWithStats.useQuery(
    {},
    {
      refetchOnMount: true,
    },
  );

  return (
    <DashboardLayout contentIsCard={true}>
      <ProjectsTable
        title="All Projects"
        subtitle="Every project you have access to, across all your workspaces."
        projects={data?.projects}
        isLoading={isLoading}
        showWorkspaceColumn
      />
      {children}
      <Outlet />
    </DashboardLayout>
  );
};

export default AllProjects;
